import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Commission} from './commission.model';
import {DateUtils} from 'ng-jhipster';

@Injectable()
export class CommissionService {

    private resourceUrl = 'api/commissions';


    private static getTime(date?: Date) {
        return date != null ? new Date(date).getTime() : 0;
    }

    private static copyCommission(commission: Commission): Commission {
        if (commission.heureCommission != null) {
            commission.dateCommission = new Date(commission.dateCommission.getFullYear(),
                commission.dateCommission.getMonth(), commission.dateCommission.getDate(),
                commission.heureCommission.getHours(), commission.heureCommission.getMinutes(),
                commission.heureCommission.getSeconds());
        }
        if (commission.heureCoupure != null) {
            commission.dateCoupure = new Date(commission.dateCoupure.getFullYear(),
                commission.dateCoupure.getMonth(), commission.dateCoupure.getDate(),
                commission.heureCoupure.getHours(), commission.heureCoupure.getMinutes(),
                commission.heureCoupure.getSeconds());
        }
        if (commission.heurePublication != null) {
            commission.datePublication = new Date(commission.datePublication.getFullYear(),
                commission.datePublication.getMonth(), commission.datePublication.getDate(),
                commission.heurePublication.getHours(), commission.heurePublication.getMinutes(),
                commission.heurePublication.getSeconds());
        }
        if (commission.heureLimiteAvis != null) {
            commission.dateLimiteAvis = new Date(commission.dateLimiteAvis.getFullYear(),
                commission.dateLimiteAvis.getMonth(), commission.dateLimiteAvis.getDate(),
                commission.heureLimiteAvis.getHours(), commission.heureLimiteAvis.getMinutes(),
                commission.heureLimiteAvis.getSeconds());
        }
        if (commission.heureLimiteConfirmation != null) {
            commission.dateLimiteConfirmation = new Date(commission.dateLimiteConfirmation.getFullYear(),
                commission.dateLimiteConfirmation.getMonth(), commission.dateLimiteConfirmation.getDate(),
                commission.heureLimiteConfirmation.getHours(), commission.heureLimiteConfirmation.getMinutes(),
                commission.heureLimiteConfirmation.getSeconds());
        }
        return commission;
    }

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(commission: Commission): Observable<Commission> {
        let copy: Commission = Object.assign({}, commission);
        return this.http.post(this.resourceUrl, CommissionService.copyCommission(copy)).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }

    update(commissions: Commission[]): Observable<Commission[]> {
        let copy: Commission[] = commissions.splice(0);
        copy.map(c => CommissionService.copyCommission(c));
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            let comms = res.json();
            comms.map(c => this.convertHeures(c));
            return comms;
        });
    }

    find(id: number): Observable<Commission> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            return this.convertHeures(jsonResponse);
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.campagneId) {
            params.set('campagneId', req.campagneId);
        }
        if (req && req.commissionListIds) {
            params.set('commissionListIds', req.commissionListIds);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map((res: any) => this.convertResponse(res));
    }

    delete(ids: number[]): Observable<Response> {
        if (ids != null) {
            let response = null;
            ids.forEach(id => {
                response = this.http.delete(`${this.resourceUrl}/${id}`);
            });
            return response;
        }
        return null;
    }

    public convertHeures(commission: Commission): Commission {
        commission.dateCommission = this.dateUtils.convertDateTimeFromServer(commission.dateCommission);
        commission.datePublication = this.dateUtils.convertDateTimeFromServer(commission.datePublication);
        commission.dateCoupure = this.dateUtils.convertDateTimeFromServer(commission.dateCoupure);
        commission.dateLimiteAvis = this.dateUtils.convertDateTimeFromServer(commission.dateLimiteAvis);
        commission.dateLimiteConfirmation = this.dateUtils.convertDateTimeFromServer(commission.dateLimiteConfirmation);
        commission.heureCoupure = commission.dateCoupure;
        commission.heurePublication = commission.datePublication;
        commission.heureLimiteAvis = commission.dateLimiteAvis;
        commission.heureCommission = commission.dateCommission;
        commission.heureLimiteConfirmation = commission.dateLimiteConfirmation;
        return commission;
    }
    public formatDateLimiteConfirmation(commission: Commission, lang: string): string {
        if (!commission.dateLimiteConfirmation) return null;

        const date = new Date(commission.dateLimiteConfirmation);
        if (lang === 'fr') {
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        } else {
            return date.toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        }
    }
    toOrderedLabelValue(commission: Commission[]) {
        return commission.sort((a, b) =>
            CommissionService.getTime(b.dateCommission) - CommissionService.getTime(a.dateCommission)).map(comm => ({
            'label': comm.libelle,
            'value': comm.id
        }));
    }


    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateCommission = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCommission);
            jsonResponse[i].datePublication = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].datePublication);
            jsonResponse[i].dateCoupure = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCoupure);
            jsonResponse[i].dateLimiteAvis = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateLimiteAvis);
            jsonResponse[i].dateLimiteConfirmation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateLimiteConfirmation);
        }
        res._body = jsonResponse;
        return res;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/commission/commission.service.ts